<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Recode' }}
                </div>
                <div class="">
                  <input
                    v-model="searchParams.recode"
                    type="text"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Lễ tân' }}
                </div>
                <div class="">
                  <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['code', 'name']"
                    :selected-index-field-value="searchParams.user"
                    :disabled="disableHasInvoice"
                    :value="searchParams.useraccountID"
                    :rows="receptionRows"
                    :columns="receptionCols"
                    :dropdown-width="400"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectReception"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span>
                          {{
                            `${selectedData?.code || ''} - ${
                              selectedData?.full_name || ''
                            }`
                          }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khoảng ngày' }}
                </div>
                <div class="" style="position: relative">
                  <CalendarRange
                    v-model="searchParams.date"
                    mode="date"
                    :disabled="disableHasInvoice"
                    @input="onDatePickerChange"
                  />
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khách sạn' }}
                </div>
                <div class="">
                  <el-select
                    v-model="searchParams.hotelIds"
                    :disabled="disableHasInvoice"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container" style="display: flex">
            <div class="das-form-title">
              <span class="main-title">
                {{
                  `Báo cáo chi tiết doanh thu đặt phòng và dịch vụ theo nhân viên`
                }}
              </span>
            </div>

            <DownloadBtn
              @openNoteDialog="dialogNoteVisible = true"
              @exportExcel="downloadExcel"
            />
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              :auto-size-cell="true"
            />
          </div>
        </div>
      </div>
    </div>

    <NoteDialog v-model="dialogNoteVisible">
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Recode: Hiển thị mã đặt phòng</li>
            <li>Ngày: Ngày đặt phòng. format: DDMMYYYY</li>
            <li>Tiền phòng: Tổng tiền phòng sau khi giảm giá của đặt phòng</li>
            <li>
              Dịch vụ: Các dịch vụ buồng phòng + Dịch vụ đặc biệt (Không bao gồm
              ăn uống)
            </li>
            <li>Tổng cộng: Tiền phòng + Dịch vụ</li>
            <li>User: Họ và tên người thực hiện</li>
            <li style="font-weight: bold">Lưu ý</li>
            <ul>
              <li>
                Với những cột là số tiền: tự động hiển thị dấu phẩy phân tách.
                Ví dụ: 100000(1 trăm) hiển thị: 100,000
              </li>
              <li>Để hết liệt kê , không phân trang</li>
            </ul>
          </ul>
        </div>
      </div>
    </NoteDialog>
  </div>
</template>

<script>
import DownloadBtn from './components/DownloadBtn.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import NoteDialog from './components/NoteDialog.vue'

import { getAccount } from '@/api/reception/common'
import { getAllHotel } from '@/api/hotel'
import {
  getBookAndServiceReport,
  getBookAndServiceReportExcel
} from '@/api/report_service/datntReport'

import { formatVND } from '@/utils/commonUtils'
import { downFile } from '@/utils/file-handler'

export default {
  components: { DownloadBtn, CalendarRange, NoteDialog },
  data() {
    return {
      searchParams: {
        user: null,
        recode: null,
        hotelIds: [],
        date: {
          start: this.$moment().format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        dateFrom: null,
        dateTo: null
      },
      defaultSearchParams: {
        user: null,
        recode: null,
        hotelIds: [],
        date: {
          start: this.$moment().format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        dateFrom: null,
        dateTo: null
      },

      // input
      disableRecode: true,
      disableHasInvoice: false,

      // data for search
      hotelList: [],
      receptionRows: [],
      receptionCols: [
        {
          headerName: 'Tên',
          field: 'full_name',
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Code',
          field: 'code',
          // tooltipFiled: 'desc',
          flex: 1
        }
      ],

      // grid
      columns: [
        {
          headerName: 'Recode',
          field: 'recode'
        },
        {
          headerName: 'Ngày',
          field: 'date'
        },
        {
          headerName: 'Tiền phòng',
          field: 'roomCharge',
          cellRenderer: params => formatVND(params.data.roomCharge, null),
          cellClass: 'ag-cell-right'
        },
        {
          headerName: 'Dịch vụ',
          field: 'serviceCharge',
          cellRenderer: params => formatVND(params.data.serviceCharge, null),
          cellClass: 'ag-cell-right'
        },
        {
          headerName: 'Tổng cộng',
          field: 'amountMoney',
          cellRenderer: params => formatVND(params.data.amountMoney, null),
          cellClass: 'ag-cell-right'
        },
        {
          headerName: 'Nhân viên',
          field: 'user'
        }
      ],
      rows: [],

      // dialog
      dialogNoteVisible: false
    }
  },

  watch: {
    'searchParams.recode'(nv, ov) {
      if (nv) {
        this.disableHasInvoice = true
        this.searchParams.date = {
          start: null,
          end: null
        }
        this.searchParams.hotelIds = null
        this.searchParams.user = null
      } else {
        this.disableHasInvoice = false
        this.searchParams = { ...this.defaultSearchParams }
      }
    }
  },

  async mounted() {
    await this.getListHotel()
    await this.getListReception()

    await this.fnGetBookAndServiceReport()
  },

  methods: {
    onSearch() {
      this.fnGetBookAndServiceReport()
    },
    onResetSearch() {
      this.searchParams = { ...this.defaultSearchParams }
      this.disableRecode = true
      this.disableHasInvoice = false
      this.fnGetBookAndServiceReport()
    },

    onDatePickerChange() {
      // console.log(this.searchParams.date)
      if (this.searchParams.date.end || this.searchParams.date.start) {
        this.disableRecode = true
      } else {
        this.disableRecode = false
      }
    },

    // chon bo phan Le tan
    onSelectReception(selected) {
      this.searchParams.user = selected?.id
    },

    // handle api call
    async fnGetBookAndServiceReport() {
      try {
        const query = {
          user: this.searchParams.user,
          hotelIdList: this.searchParams.hotelIds,
          dateFrom: this.searchParams.date.start,
          dateTo: this.searchParams.date.end,
          recode: this.searchParams.recode
        }
        const res = await getBookAndServiceReport(query)
        this.rows = res.data.map(item => {
          if (item?.hotel) {
            return {
              ...item,
              isFullWidthRow: true,
              name: item.hotel
            }
          }
          if (item.isFinalTotal !== undefined) {
            if (item.isFinalTotal) {
              return {
                recode: 'Tổng cộng',
                roomCharge: item?.totalRoomCharge,
                amountMoney: item?.totalAmountMoney,
                serviceCharge: item?.totalServiceCharge
              }
            } else {
              return {
                recode: 'Tổng',
                roomCharge: item?.totalRoomCharge,
                amountMoney: item?.totalAmountMoney,
                serviceCharge: item?.totalServiceCharge
              }
            }
          }
          return item
        })
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        //
      }
    },
    async downloadExcel() {
      try {
        const query = {
          user: this.searchParams.user,
          hotelIdList: this.searchParams.hotelIds,
          dateFrom: this.searchParams.date.start,
          dateTo: this.searchParams.date.end,
          recode: this.searchParams.recode
        }
        const res = await getBookAndServiceReportExcel(query)
        const date = this.$moment().format('DD-MM-YYYY')
        downFile(
          res,
          'bao_cao_chi_tiet_doanh_thu_dat_phong_va_dich_vu_theo_nhan_vien_' +
            date +
            '.xlsx'
        )
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        //
      }
    },

    async getListReception() {
      // Le tan
      const res = await getAccount({ department: 'FO' })
      this.receptionRows = res.data.map(item => {
        return {
          id: item.account.id,
          code: item.account.code,
          full_name: item.account.full_name
        }
      })
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    }
  }
}
</script>
